import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useDispatch } from "react-redux";
import { appointmentDetail } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/prescriptionSlice";

const UseFetchAppointmentDetailsPatient = (id) => {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ["appointmentDetail", id],
    queryFn: () => appointmentDetail(id),
    enabled: !!id,
    onError: () => {
      dispatch(setError(true));
      dispatch(setLoading(false));
    },
    onSettled: () => {
      dispatch(setLoading(false));
    },
  });
};

export default UseFetchAppointmentDetailsPatient;
